<template>
   <el-dialog
      :title="title"
      :append-to-body="true"
      class="multiSuccessView"
      :visible.sync="multiSuccessVisible"
       :close-on-click-modal="false"
      :before-close="closeView"
      width="25%">
      <!-- <div class="flex">
        <div>
          <span class="el-icon-circle-check icons"></span>
        </div>
        <div>
          <div>
            添加完成
          </div>
          <div class="showMes">
            数量：{{multiParams.deviceNum}}
          </div>
        </div>
      </div>
      <div class="border"></div>
      <div class="flex">
        <div>
          <span class="el-icon-circle-check icons"></span>
        </div>
        <div>
          <div>
           下载设备证书
          </div>
          <div class="showMes">
            添加完成后可下载设备证书，您可以在“批次管理”中随时下载本文件。
          </div>
          <el-button class="downLoadBtn"  @click="download" type="primary" size="small">下载设备证书</el-button>
        </div>
      </div> -->
  <el-timeline>
    <el-timeline-item
      icon="el-icon-circle-check"
      type="primary"
      size="large">
      <template v-if="multiParams.deviceNum !== ''&&!isNaN(multiParams.deviceNum) && multiParams.deviceNum>=0">
          <div class="content">
            添加完成
          </div>
          <div class="showMes">
           <p> 成功数量：<span style="color:green">{{multiParams.deviceNum}}</span></p>
           <p v-if="multiParams.errorNum">失败数量：<span  style="color:red">{{multiParams.errorNum}}</span></p>
            <p v-if="multiParams.errorNum"  style="color:red">注意：失败数据可在批次管理异常数据中查看</p>
          </div>
      </template>
      <template v-else>
          <div>
            <span class="el-icon-loading"></span><span class="content">正在添加，请等待</span>
          </div>
          <div class="showMes">
            添加设备需要一些时间，请耐心等待
          </div>
      </template>
    </el-timeline-item>
    <el-timeline-item
      icon="el-icon-circle-check"
      :type="multiParams.deviceNum>0?'primary':''"
      size="large">
      <template>
          <div class="content">
           下载设备证书
          </div>
          <div class="showMes">
            添加完成后可下载设备证书，您可以在“批次管理”中随时下载本文件。
          </div>
          <el-button v-if="multiParams.deviceNum>0 && multiParams.url" class="downLoadBtn"  @click="download" type="primary" size="small">下载设备证书</el-button>
        </template>
    </el-timeline-item>
  </el-timeline>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeView">关 闭</el-button>
      </span>
     </el-dialog>
</template>
<script>
import { loadFileByUrl } from '@/utils'
export default {
  props: {
    multiSuccessVisible: {
      type: Boolean
    },
    multiParams: {
      type: Object
    }
  },
  computed: {
    title () {
      if (!isNaN(this.multiParams.deviceNum) && this.multiParams.deviceNum > 0) {
        return '添加完成'
      } else {
        return '正在添加设备...'
      }
    }
  },
  data () {
    return {
    }
  },
  watch: {
    'multiParams.deviceNum' () {
      console.log('multiParams.deviceNum变化了：', this.multiParams)
    }
  },
  methods: {
    closeView () {
      if (this.multiParams.deviceNum === 0) {
        this.$confirm('关闭后，可在批次管理中查看设备添加情况！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.$emit('closeView')
        })
      } else {
        this.$emit('closeView')
      }
    },
    download () {
      if (this.multiParams.url) {
        // window.open(this.multiParams.url)
        loadFileByUrl(this.multiParams.url)
      } else {
        this.$message.error('下载出错')
      }
    }
  }
}
</script>
<style lang="less" scope>
.multiSuccessView{
  .content{
    font-weight: bold;
  }
    .flex{
      display: flex;
      &:nth-child(1){
         margin-top: 20px;
      }
    }
    .border{
      border-left: solid 1px #409EFF;
      height: 20px;
      margin-left: 15px;
      margin-bottom: 10px;
    }
    .icons{
      color: #409EFF;
      margin-right: 10px;
      font-size: 30px;
    }
    .showMes{
      font-size: 12px;
      line-height: 20px;
      color:#b2b3b7;
      &:nth-child(1){
         margin-bottom: 10px;
      }
    }
    .downLoadBtn{
        margin-top: 20px;
      }
  }
</style>
